import styled from '@emotion/styled';

export const CommonParagraph = styled.div`
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
    line-height: ${({ theme }) => theme.typography.lineHeights.body.medium};
    color: black;
    padding: 8px;
    max-width: 100%;
`;

export const HeaderLeft = styled(CommonParagraph)`
    font-size: 32px;
    padding: 0px 0px 32px 0px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray40};
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const HeaderTitleLeft = styled(CommonParagraph)`
    font-size: 28px;
    padding: 32px 0px 16px 0px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray40};
`;